import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import Dropzone from "react-dropzone";
import Papa from "papaparse";
import ContentLoader from "react-content-loader";
import loading from "../img/loading.svg";

class DropPatients extends React.Component {
  state = {
    patients: [],
    loading: false
  };

  generateBackupComment = (p, newPatient) => {
    //debugger;
    let lines = [];
    lines.push(
      p.email.toLowerCase() !== newPatient.email.toLowerCase()
        ? `Email: ${p.email}
    `
        : ""
    );
    lines.push(
      p.portable.toLowerCase() !== newPatient.portable.toLowerCase()
        ? `Portable: ${p.portable}
    `
        : ""
    );
    lines.push(
      p.telephone.toLowerCase() !== newPatient.telephone.toLowerCase()
        ? `Telephone: ${p.telephone}
    `
        : ""
    );
    lines.push(
      p.adresse.toLowerCase() !== newPatient.adresse.toLowerCase()
        ? `Adresse: ${p.adresse}
    `
        : ""
    );
    lines.push(
      p.codepostal.toLowerCase() !== newPatient.codepostal.toLowerCase()
        ? `Code postal: ${p.codepostal}
    `
        : ""
    );
    lines.push(
      p.ville.toLowerCase() !== newPatient.ville.toLowerCase()
        ? `Ville: ${p.ville}
    `
        : ""
    );
    lines.push(
      p.comment.length > 0
        ? `Note: ${p.comment.replace(
            `Anciennes données:
       Note: `,
            ""
          )}`
        : ""
    );
    if (lines.length > 0) {
      lines = [
        `Anciennes données:
       `,
        ...lines
      ];
      return lines.join("");
    }
    return "";
  };

  /*

  ville: $ville
  comm
   */

  onDrop = files => {
    this.setState({
      loading: true
    });
    let promises = [];
    Papa.parse(files[0], {
      header: true,
      delimiter: ";",
      complete: results => {
        promises = results.data.map(p => {
          //    results.data.forEach(async p => {
          if (p.matricule && p.matricule.length > 0) {
            return this.props
              .createPatientMutation({
                variables: p
              })
              .catch(res => {
                res.graphQLErrors.forEach(error => {
                  if (error.code === 3010) {
                    //matricule already exists, update
                    const patientToUpdate = this.state.patients.find(
                      patient => patient.matricule === p.matricule
                    );
                    p.id = patientToUpdate.id;
                    p.comment = this.generateBackupComment(patientToUpdate, p);
                    return this.props
                      .updatePatientMutation({
                        variables: p
                      })
                      .catch(res => {
                        console.error("update patients");
                      });
                  } else {
                    console.error("create patients");
                  }
                });
              });
          }
          return null;
        }); //map
        Promise.all(promises).then(ids => {
          this.setState({ loading: false });
          this.props.getAllPatientsQuery.refetch();
        });
      }
    });
  };
  componentDidMount() {}

  componentWillReceiveProps(newProps) {
    if (!newProps.getAllPatientsQuery.loading) {
      let skipNum = newProps.getAllPatientsQuery.allPatients.length;
      if (this.state.patients.length > 0) {
        skipNum = this.state.patients.length + 1000;
      }
      newProps.getAllPatientsQuery.refetch({ skipNum });

      /*  newProps.getAllPatientsQuery.fetchMore({
        updateQuery: (previousResult, { fetchMoreResult, variables }) => {

            "newProps.getAllPatientsQuery",
            newProps.getAllPatientsQuery.allPatients.length
          );
          //    let
          skipNum += fetchMoreResult.allPatients.length;
          //  debugger;
          if (fetchMoreResult.allPatients.length === 0) {
            return previousResult;
          }
          return {
            ...previousResult,
            //  variables: { skipNum: 555 },
            // Add the new feed data to the end of the old feed data.
            allPatients: [
              ...previousResult.allPatients,
              ...fetchMoreResult.allPatients
            ]
          };
        }, //
        variables: { skipNum: skipNum }
      });*/

      this.setState({
        patients: [
          ...this.state.patients,
          ...newProps.getAllPatientsQuery.allPatients
        ]
      });
    }
  }

  render() {
    if (this.props.getAllPatientsQuery.loading) {
      return (
        <div className="columns  is-centered">
          <div className="column is-4 has-text-centered">
            <p />
            <ContentLoader type="facebook" />
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <p className="has-text-centered">
          Vous avez {this.state.patients.length} patients enregistrés
        </p>
        <br />
        <Dropzone
          onDrop={this.onDrop}
          multiple={false}
          className="drop-zone"
          activeClassName="drop-zone-active"
          acceptClassName="drop-zone-accept"
          rejectClassName="drop-zone-reject"
        >
          <p>Déposez votre fichier .csv ici!</p>
          {this.state.loading ? (
            <figure className="image is-32x32">
              <img alt="loading" src={loading} />
            </figure>
          ) : null}
        </Dropzone>
      </React.Fragment>
    );
  }
}

const CREATE_PATIENT_MUTATION = gql`
  mutation CreatePatientMutation(
    $nom: String!
    $prenom: String!
    $telephone: String
    $portable: String
    $adresse: String
    $codepostal: String
    $email: String
    $ville: String
    $matricule: String!
  ) {
    createPatient(
      nom: $nom
      prenom: $prenom
      telephone: $telephone
      portable: $portable
      adresse: $adresse
      codepostal: $codepostal
      email: $email
      ville: $ville
      matricule: $matricule
    ) {
      id
    }
  }
`;

const UPDATE_PATIENT_MUTATION = gql`
  mutation UpdatePatientMutation(
    $id: ID!
    $nom: String!
    $prenom: String!
    $telephone: String
    $portable: String
    $adresse: String
    $codepostal: String
    $email: String
    $ville: String
    $comment: String
    $matricule: String!
  ) {
    updatePatient(
      id: $id
      nom: $nom
      prenom: $prenom
      telephone: $telephone
      portable: $portable
      adresse: $adresse
      codepostal: $codepostal
      email: $email
      ville: $ville
      matricule: $matricule
      comment: $comment
    ) {
      id
    }
  }
`;

/*const ALL_PATIENTS_QUERY = gql`
  query AllPatientsQuery {
    allPatients(orderBy: nom_ASC) {
      id
      nom
      prenom
      matricule
    }
  }
`;*/
const ALL_PATIENTS_QUERY = gql`
  query AllPatientsQuery($skipNum: Int!) {
    allPatients(orderBy: nom_ASC, first: 1000, skip: $skipNum) {
      id
      nom
      prenom
      matricule
      telephone
      portable
      adresse
      codepostal
      email
      ville
      comment
    }
  }
`;

export default compose(
  graphql(CREATE_PATIENT_MUTATION, {
    name: "createPatientMutation"
  }),
  graphql(ALL_PATIENTS_QUERY, {
    name: "getAllPatientsQuery",
    options: { variables: { skipNum: 0 } }
  }),
  graphql(UPDATE_PATIENT_MUTATION, {
    name: "updatePatientMutation"
  })
)(DropPatients);



// WEBPACK FOOTER //
// ./src/components/DropPatients.js